import type {EnrichedIssueListItem, IssueLinkedPullRequestSummary} from '../types/list-types'

export type GetIssueReferenceParams = {
  isAccountIssue?: boolean
  issue: Pick<EnrichedIssueListItem, 'number' | 'repoNameWithOwner'>
  ownerLogin: string
  showRepository: boolean
}

export function getIssueReference({isAccountIssue, issue, ownerLogin, showRepository}: GetIssueReferenceParams) {
  if (!showRepository) return `#${issue.number}`
  if (isAccountIssue) return `${ownerLogin}#${issue.number}`
  return `${issue.repoNameWithOwner}#${issue.number}`
}

export function getLinkedPullRequestReference(
  pullRequest: Pick<IssueLinkedPullRequestSummary, 'number' | 'repoNameWithOwner'>,
) {
  if (pullRequest.number == null) return pullRequest.repoNameWithOwner ?? 'Pull request'
  return pullRequest.repoNameWithOwner
    ? `${pullRequest.repoNameWithOwner}#${pullRequest.number}`
    : `#${pullRequest.number}`
}
